import { Action } from '@ngrx/store';
import {
    RuleEntry,
    RuleFilterInput
} from 'app/api/rule.api.service';
import { KeyStringFilterInput } from 'app/api/common.api.types';
import { CreateRuleEntryInput, UpdateRuleEntryInput, DeleteRuleEntryInput } from 'app/api/API.service';

export interface RuleQuery {
    companyId: string;
    key?: KeyStringFilterInput;
    filter?: RuleFilterInput;
}

export enum RuleActionTypes {
    RuleRequested = '[Rule View] Rule requested',
    RuleLoaded = '[Rule API] Rule loaded',
    RuleCancelled = '[Rule API] Rule cancelled',
    RuleEntryCreateRequested = '[Rule View] Rule entry create requested',
    RuleEntryCreated = '[Rule API] Rule entry created',
    RuleEntryCreateCancelled = '[Rule API] Rule entry create cancelled',
    RuleEntryUpdateRequested = '[Rule View] Rule entry update requested',
    RuleEntryUpdated = '[Rule API] Rule entry updated',
    RuleEntryUpdateCancelled = '[Rule API] Rule entry update cancelled',
    RuleEntryDeleteRequested = '[Rule View] Rule entry delete requested',
    RuleEntryDeleted = '[Rule API] Rule entry deleted',
    RuleEntryDeleteCancelled = '[Rule API] Rule entry delete cancelled',
}

// LOAD ENTRIES
export class RuleRequested implements Action {
    readonly type = RuleActionTypes.RuleRequested;
    constructor(public payload: RuleQuery) {}
}
export class RuleLoaded implements Action {
    readonly type = RuleActionTypes.RuleLoaded;
    constructor(public payload: { rule: RuleEntry[] }) {}
}
export class RuleCancelled implements Action {
    readonly type = RuleActionTypes.RuleCancelled;
    constructor(public payload: { errorMessage: string }) {}
}

// CREATE ENTRY
export class RuleEntryCreateRequested implements Action {
    readonly type = RuleActionTypes.RuleEntryCreateRequested;
    constructor(public payload: { input: CreateRuleEntryInput }) {}
}
export class RuleEntryCreated implements Action {
    readonly type = RuleActionTypes.RuleEntryCreated;
    constructor(public payload: { entry: RuleEntry }) {}
}
export class RuleEntryCreateCancelled implements Action {
    readonly type = RuleActionTypes.RuleEntryCreateCancelled;
    constructor(public payload: { errorMessage: string }) {}
}

// UPDATE ENTRY
export class RuleEntryUpdateRequested implements Action {
    readonly type = RuleActionTypes.RuleEntryUpdateRequested;
    constructor(public payload: { input: UpdateRuleEntryInput }) {}
}
export class RuleEntryUpdated implements Action {
    readonly type = RuleActionTypes.RuleEntryUpdated;
    constructor(public payload: { entry: RuleEntry }) {}
}
export class RuleEntryUpdateCancelled implements Action {
    readonly type = RuleActionTypes.RuleEntryUpdateCancelled;
    constructor(public payload: { errorMessage: string }) {}
}

// DELETE ENTRY
export class RuleEntryDeleteRequested implements Action {
    readonly type = RuleActionTypes.RuleEntryDeleteRequested;
    constructor(public payload: { input: DeleteRuleEntryInput }) {}
}
export class RuleEntryDeleted implements Action {
    readonly type = RuleActionTypes.RuleEntryDeleted;
    constructor(public payload: { entry: RuleEntry }) {}
}
export class RuleEntryDeleteCancelled implements Action {
    readonly type = RuleActionTypes.RuleEntryDeleteCancelled;
    constructor(public payload: { errorMessage: string }) {}
}

export type RuleActions =
  RuleRequested
    | RuleLoaded
    | RuleCancelled
    | RuleEntryCreateRequested
    | RuleEntryCreated
    | RuleEntryCreateCancelled
    | RuleEntryUpdateRequested
    | RuleEntryUpdated
    | RuleEntryUpdateCancelled
    | RuleEntryDeleteRequested
    | RuleEntryDeleted
    | RuleEntryDeleteCancelled;
